// provider membership dapi event resources
export var provider_membership_add = "/center/provider/membership/add";
export var provider_membership_rem = "/center/provider/membership/remove";
export var provider_edit_saved = "/center/provider/edit/saved";
export var provider_edit_delete = "/center/provider/edit/delete";
export var provider_created = "/center/provider/created";

// app dapi event resources
export var app_created = "/center/app/created";
export var app_edit_changed_saved = "/center/app/edit/changed";
export var app_edit_provider_changed = "/center/app/edit/changed/provider";
export var app_edit_deleted = "/center/app/edit/deleted";

// organization dapi event resources
export var organization_created = '/center/organization/created';

// tenant dapi event resources
export var tenant_deleted = '/center/tenant/deleted';
export var tenant_created = '/center/tenant/created';
export var tenant_updated = '/center/tenant/updated';